import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

const lightTheme = {
  root: {
    '& $header': {
      color: TextColors.dark,
    },
  },
};

const darkTheme = {
  root: {
    '& $header': {
      color: TextColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.light-theme': lightTheme,
      '&.dark-theme': darkTheme,
    },
    heading: {
      marginBottom: muiTheme.spacing(3.5),
    },
    content: {
      marginBottom: muiTheme.spacing(4),

      [muiTheme.breakpoints.down('xs')]: {
        marginLeft: muiTheme.spacing(-4),
        marginRight: muiTheme.spacing(-4),
        width: `calc(100% + ${muiTheme.spacing(8)}px)`,
        overflow: 'hidden',
      },
    },
    cta: {
      padding: muiTheme.spacing(3.75, 0),
      textAlign: 'center',
    },
  }),
  { name: 'GenMarketplaceCMSBlock' },
);

export default useStyles;
